import template from "./pProcessGroupConfigurations.html";

export function pProcessGroupConfigurationsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pProcessGroupConfigurationsController,
    controllerAs: 'pProcessGroupConfigurations',
    bindToController: true
  };

  return directive;
}

class pProcessGroupConfigurationsController {
  constructor(Auth, Admin, $routeParams, $q, $scope, $interval, $translate, Notes) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.$scope = $scope;
    this.$interval = $interval;
    this.$translate = $translate;
    this.Notes = Notes;

    this.init();

    this.tooltip = {
      processes: {
        name: {
          info: this.$translate.instant("TOOLTIP.LOCAL_NAME_TOOLTIP")
        },
        description: {
          info: this.$translate.instant("TOOLTIP.LOCAL_DESCRIPTION_TOOLTIP")
        },
        isOpportunityTime: {
          info: this.$translate.instant("TOOLTIP.OPPORTUNITY_TIME_TOOLTIP")
        }
      }
    };

    this.fields = {
      idName: "info",
      name: "info",
      description: "info",
      commentRequiredByDefault: "info",
      hasVolumeByDefault: "info",
      outputs: "info",
      valueAddedByDefault: "info",
      allowChangingValueAdded: "info",
      includeInReports: "info",
      isHidden: "info",
      isOpportunityTime: "info",
      isVacation: "info"
    };

    this.sort = {
      idName: "idName",
      name: "name",
      description: null,
      commentRequiredByDefault: "commentRequiredByDefault",
      hasVolumeByDefault: "hasVolumeByDefault",
      outputs: "outputs",
      valueAddedByDefault: "valueAddedByDefault",
      allowChangingValueAdded:" allowChangingValueAdded",
      includeInReports: "includeInReports",
      isHidden: "isHidden",
      isOpportunityTime: "isOpportunityTime",
      isVacation: "isVacation"
    };

    this.actions = [];

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingProcess",
        fa: "fa-pencil-alt"
      }
    ];

    this.problemFields = {
      name: "info",
      description: "info"
    };

    this.problemRowActions = [
      {
        name: "switch",
        function: "switchProblem",
        switchField: "active"
      }
    ];

    this.sideBarConfig = {};

    /*
    * b-dialog-card data
    */

    this.newProcessData = {
      name: {
        type: "text"
      },
      idName: {
        type: "text"
      },
      description: {
        type: "textarea"
      },
      commentRequiredByDefault: {
        type: "checkbox",
        isNotRequired: true
      },
      commentRequired: {
        type: "statistic",
        isNotRequired: true
      },
      hasVolumeByDefault: {
        type: "checkbox",
        isNotRequired: true
      },
      hasVolume: {
        type: "statistic",
        isNotRequired: true
      },
      outputTypeList: {
        type: 'toDoList',
        isNotRequired: true
      },
      valueAddedByDefault: {
        type: "checkbox",
        isNotRequired: true
      },
      valueAdded: {
        type: "statistic",
        isNotRequired: true
      },
      allowChangingValueAdded: {
        type: "checkbox",
        isNotRequired: true
      },
      includeInReports: {
        type: "checkbox",
        isNotRequired: true
      },
      productivityPoints: {
        type: "text",
        isNotRequired: true
      },
      isHidden: {
        type: "checkbox",
        isNotRequired: true
      },
      isOpportunityTime: {
        type: "checkbox",
        isNotRequired: true
      },
      isVacation: {
        type: 'checkbox',
        isNotRequired: true
      },

    };

    this.editProcessData = angular.fromJson(angular.toJson(this.newProcessData));

    this.newProblemValues = {
      "processGroupCountryConfigurationId": this.$routeParams.processId
    };

    this.newProblemData = {
      name: {
        type: "text"
      },
      description: {
        type: "textarea"
      }
    };

    $scope.$watch("pProcessGroupConfigurations.refresh", (n) => {
      if (n == true) {
        this.init();
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        if (!this.user.isAdmin) {
          if (!this.user.isLocalAdmin)
            this.Auth.handleUnauthorized();
        }

        if(this.user.isLocalAdmin) {

          delete this.fields.commentRequiredByDefault;
          delete this.fields.includeInReports;
          delete this.fields.isVacation;

          this.editProcessData.idName.editionDisabled = true;
          delete this.editProcessData.commentRequiredByDefault;
          delete this.editProcessData.commentRequired;
          this.editProcessData.hasVolumeByDefault.type = "hidden";
          this.editProcessData.hasVolume.type = "statisticInfo";
          this.editProcessData.valueAddedByDefault.type = "hidden";
          this.editProcessData.valueAdded.type = "statisticInfo";
          delete this.editProcessData.includeInReports;
          delete this.editProcessData.productivityPoints;
          delete this.editProcessData.isOpportunityTime;
          delete this.editProcessData.isVacation;
        }

        Promise.all([this.Admin.getGroupCountryConfigurations(this.$routeParams.processId), this.Admin.getCountry(this.$routeParams.name)]).then(
          (success) => {
            this.pgcc = success[0].data.processGroupCountryConfiguration;

            function compare(a, b) {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }

              return 0;
            }

            this.processes = success[0].data.processes.sort(compare);

            this.processes.map(i => {
              success[0].data.processStats.filter(s => {
                return s.processId == i.id;
              }).map(s => {
                i.stats = s;
                i.outputs = i.outputTypeList && i.outputTypeList.outputs ? i.outputTypeList.outputs.length : 0;
              });
            });

            if(this.refresh) {
              const processToRefresh = angular.copy(this.processes.find(i => i.id == this.editProcessValues.id));
              processToRefresh.outputTypeList = this.editProcessValues.outputTypeList;
              processToRefresh.outputTypeListValue = this.editProcessValues.outputTypeListValue;
              this.editProcessValues = processToRefresh;
              this.refresh = false;
            }

            if(this.user.isAdmin) {
              this.actions = [
                {
                  name: "new",
                  functionName: "startAddingNewProcess",
                  fa: "fa-plus"
                }
              ];

              this.rowActions = [
                {
                  name: "edit",
                  functionName: "startEditingProcess",
                  fa: "fa-pencil-alt"
                },
                {
                  name: "delete",
                  functionName: "startDeletingProcess",
                  fa: "fa-trash"
                }
              ];
            }

            
            this.problems = success[1].data.problems.map(problem => {
              const problemFromPGC = success[0].data.problemProcessGroupConfigurations.find(pr => pr.countryProblemId === problem.id);

              return {
                ...problem,
                active: problemFromPGC && true,
                problemId: problemFromPGC && problemFromPGC.id,
                processGroupId: this.$routeParams.processId,
                countryProblemId: problemFromPGC && problemFromPGC.countryProblemId
              };
            }).sort(compare);

            this.sideBarConfig = {
              "country": this.$routeParams.name,
              "groupCountryConfigurations": angular.fromJson(localStorage.getItem("roedl-admin-groupCountryConfigurations"))
            };
            this.featureFlags = success[1].data.country.flags;
            if (!this.featureFlags.includes('OutputType')) {
              delete this.newProcessData.outputTypeList;
              delete this.editProcessData.outputTypeList;
            }
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddingNewProcess() {
    this.newProcessProcess = true;
    this.newProcessValues = {
      includeInReports: true,
      isHidden: false,
      isOpportunityTime: false,
      isVacation: false,
      outputTypeList: [],
      outputTypeListValue: null,
      allowChangingValueAdded: true
    };
  }

  addProcess(newProcess) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    if (!newProcess.commentRequiredByDefault) {
      newProcess.commentRequiredByDefault = false;
    }
    if (!newProcess.hasVolumeByDefault) {
      newProcess.hasVolumeByDefault = false;
    }
    if (!newProcess.valueAddedByDefault) {
      newProcess.valueAddedByDefault = false;
    }
    if (!newProcess.includeInReports) {
      newProcess.includeInReports = false;
    }
    newProcess.processGroupCountryConfigurationId = this.$routeParams.processId;
    this.Admin.addGroupCountryProcess(newProcess).then(
      ({ data }) => {
        if (newProcess.outputTypeList && newProcess.outputTypeList.length > 0)
          this.Admin.createOrUpdateOutputList(data.id, newProcess.outputTypeList.filter(output => output && output.length > 0)).then(
            () => {
              this.newProcessProcess = false;
              this.init();
            },
            (error) => {
              this.state = 'loaded';
              this.Notes.postNote({type: "error", error: error});
            }
          );
        else {
          this.newProcessProcess = false;
          this.init();
        }
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingProcess(proc) {
    this.editProcessProcess = true;
    this.editProcessValues = angular.copy(proc);
    this.editProcessValues.outputTypeList = proc.outputTypeList && proc.outputTypeList.outputs.length ? proc.outputTypeList.outputs : [];
    this.editProcessValues.outputTypeListValue = null;
  }

  updateProcess(proc) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    if(this.user.isLocalAdmin){
      delete proc.commentRequiredByDefault;
      delete proc.includeInReports;
      delete proc.idName;
      delete proc.isOpportunityTime;
      delete proc.isVacation;
    }

    const requests = [this.Admin.updateGroupCountryProcess(proc.id, proc)];
    const oldProcessToCompare = this.processes.find(process => process.id === proc.id);

    if (
      JSON.stringify(oldProcessToCompare.outputTypeList) !== JSON.stringify(proc.outputTypeList) &&
      !(oldProcessToCompare.outputTypeList === undefined && proc.outputTypeList.length === 0)
    )
      requests.push(this.Admin.createOrUpdateOutputList(proc.id, proc.outputTypeList.filter(output => output && output.length > 0)));

    Promise.all(requests).then(
      () => {
        this.editProcessProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingProcess(proc) {
    this.deleteProcessProcess = true;
    this.deleteProcessValues = proc;
    this.deleteProcessValues.outputTypeList = proc.outputTypeList && proc.outputTypeList.outputs && proc.outputTypeList.outputs.length ? proc.outputTypeList.outputs : [];
  }

  deleteProcess(proc) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteGroupCountryProcess(proc.id).then(
      () => {
        this.deleteProcessProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  switchProblem(problem) {
    this.state = 'loading';

    if (problem.countryProblemId) {
      this.Admin.turnProblemOff(problem.problemId).then(
        () => this.init(),
        (error) => {
          problem.active = !problem.active;
          this.state = 'loaded';
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
    else {
      this.Admin.turnProblemOn({
        processGroupCountryConfigurationId: problem.processGroupId,
        problemId: problem.id
      }).then(
        () => this.init(),
        (error) => {
          problem.active = !problem.active;
          this.state = 'loaded';
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
  }
}
